const NEWLINE = String.fromCharCode(10)
const CARRIAGE_RETURN = String.fromCharCode(13)

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const isEmail = (value: string): boolean => value.length <= 200 && EMAIL_PATTERN.test(value)

// Trims and caps free text. Single-line values collapse every run of whitespace;
// multi-line values keep their line breaks (at most one blank line in a row).
export const cleanText = (value: unknown, maxLength: number, multiline = false): string => {
    if (typeof value !== 'string') return ''

    if (!multiline) {
        return value.replace(/\s+/g, ' ').trim().slice(0, maxLength)
    }

    const lines = value
        .split(CARRIAGE_RETURN)
        .join('')
        .split(NEWLINE)
        .map((line) => line.replace(/\s+/g, ' ').trim())

    const kept: string[] = []

    for (const line of lines) {
        if (line === '' && kept[kept.length - 1] === '') continue
        kept.push(line)
    }

    return kept.join(NEWLINE).trim().slice(0, maxLength)
}
